
        // Sliders are now initialized in their respective section files
        // This prevents double initialization



        // Sticky header functionality
        function initStickyHeader() {
            const header = document.querySelector(".header");
            if (!header) {
                console.warn('Header element not found');
                return;
            }
            
            // Store original background color from inline style
            const inlineStyle = header.getAttribute('style') || '';
            let originalBgColor = '';
            if (inlineStyle.includes('background')) {
                const bgMatch = inlineStyle.match(/background:\s*([^;]+)/);
                if (bgMatch) {
                    originalBgColor = bgMatch[1].trim();
                }
            }
            
            // If no inline background, get from computed style
            if (!originalBgColor) {
                const computedBg = window.getComputedStyle(header).backgroundColor;
                if (computedBg && computedBg !== 'rgba(0, 0, 0, 0)' && computedBg !== 'transparent') {
                    originalBgColor = computedBg;
                }
            }
            
            function handleScroll() {
                const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
                
                if (scrollY > 30) {
                    if (!header.classList.contains("sticky-nav")) {
                        header.classList.add("sticky-nav");
                    }
                    
                    // Apply background color when sticky
                    if (originalBgColor && originalBgColor !== 'transparent' && originalBgColor !== 'rgba(0, 0, 0, 0)') {
                        // Convert to rgba with opacity if needed
                        if (originalBgColor.includes('rgb')) {
                            const rgbaMatch = originalBgColor.match(/rgba?\(([^)]+)\)/);
                            if (rgbaMatch) {
                                const values = rgbaMatch[1].split(',').map(v => v.trim());
                                if (values.length >= 3) {
                                    const r = values[0];
                                    const g = values[1];
                                    const b = values[2];
                                    header.style.background = `rgba(${r}, ${g}, ${b}, 0.95)`;
                                }
                            }
                        } else if (originalBgColor.includes('#')) {
                            // Convert hex to rgba
                            const hex = originalBgColor.replace('#', '').substring(0, 6);
                            if (hex.length === 6) {
                                const r = parseInt(hex.substr(0, 2), 16);
                                const g = parseInt(hex.substr(2, 2), 16);
                                const b = parseInt(hex.substr(4, 2), 16);
                                header.style.background = `rgba(${r}, ${g}, ${b}, 0.95)`;
                            }
                        }
                    }
                } else {
                    if (header.classList.contains("sticky-nav")) {
                        header.classList.remove("sticky-nav");
                    }
                    // Restore original background color
                    if (originalBgColor) {
                        header.style.background = originalBgColor;
                    } else {
                        header.style.background = '';
                    }
                }
            }
            
            // Add scroll listener
            window.addEventListener("scroll", handleScroll, { passive: true });
            
            // Check initial scroll position
            handleScroll();
            
            // Also check after a short delay to ensure it works
            setTimeout(handleScroll, 100);
        }
        
        // Initialize on DOM ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initStickyHeader);
        } else {
            initStickyHeader();
        }

        // Age verification is handled in age-verification.liquid snippet
        
        function initializeTypewriter(element) {
            const text = element.dataset.text || element.textContent.trim();
            const speed = parseInt(element.dataset.speed) || 100;
            const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            const preserveLayout = element.dataset.staticLayout === 'true';
            let index = 0;
            if (!text) return;

            element.textContent = text;

            if (prefersReducedMotion || preserveLayout) {
                return;
            }

            // Reserve text width up front to avoid heading reflow during typing.
            element.style.minWidth = text.length + 'ch';
            
            function type() {
                if (index < text.length) {
                    element.textContent += text.charAt(index);
                    index++;
                    setTimeout(type, speed);
                }
            }
            
            // Start typing after a short delay
            setTimeout(function() {
                element.textContent = '';
                type();
            }, 300);
        }

        window.initializeTypewriter = initializeTypewriter;
        
        document.addEventListener('DOMContentLoaded', function() {
            const elements = document.querySelectorAll('.typewriter-text');
            elements.forEach(function(el) {
                if (!el.dataset.initialized) {
                    initializeTypewriter(el);
                    el.dataset.initialized = 'true';
                }
            });
        });

        function formatStoreMoney(cents) {
            const parsedCents = parseInt(cents, 10) || 0;
            if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
                const moneyFormat = (window.theme && window.theme.moneyFormat) || window.Shopify.money_format || '${{amount}}';
                try {
                    return window.Shopify.formatMoney(parsedCents, moneyFormat);
                } catch (error) {
                    // Fallback below if Shopify formatter fails for any reason.
                }
            }
            return '$' + (parsedCents / 100).toFixed(2);
        }

        function buildDiscountMap(cart) {
            const map = {};
            if (!cart || !Array.isArray(cart.items)) return map;
            cart.items.forEach(function(item) {
                const variantId = String(item.variant_id || '');
                if (!variantId) return;
                const original = parseInt(item.original_price, 10) || 0;
                const final = parseInt(item.final_price, 10) || 0;
                if (original > final) {
                    map[variantId] = { original: original, final: final };
                }
            });
            return map;
        }

        function applyCardDiscountPricing(discountMap) {
            const priceRoots = document.querySelectorAll('[data-product-card-price-root]');
            priceRoots.forEach(function(root) {
                const variantId = String(root.getAttribute('data-variant-id') || '');
                const basePrice = parseInt(root.getAttribute('data-base-price'), 10) || 0;
                const baseCompare = parseInt(root.getAttribute('data-base-compare-price'), 10) || 0;
                const compareEl = root.querySelector('[data-price-compare]');
                const finalEl = root.querySelector('[data-price-final]');
                const discounted = discountMap[variantId];

                if (!finalEl) return;

                if (discounted && discounted.original > discounted.final) {
                    if (compareEl) {
                        compareEl.style.display = '';
                        compareEl.textContent = formatStoreMoney(discounted.original);
                    }
                    finalEl.textContent = formatStoreMoney(discounted.final);
                    finalEl.classList.remove('price-final--regular');
                    return;
                }

                if (baseCompare > basePrice) {
                    if (compareEl) {
                        compareEl.style.display = '';
                        compareEl.textContent = formatStoreMoney(baseCompare);
                    }
                    finalEl.classList.remove('price-final--regular');
                } else {
                    if (compareEl) {
                        compareEl.style.display = 'none';
                        compareEl.textContent = '';
                    }
                    finalEl.classList.add('price-final--regular');
                }
                finalEl.textContent = formatStoreMoney(basePrice);
            });
        }

        function applyPdpDiscountPricing(discountMap) {
            const priceRoot = document.querySelector('[data-product-price-root]');
            if (!priceRoot) return;

            const variantSelect = document.querySelector('.product-variant-id-select');
            const currentEl = priceRoot.querySelector('[data-product-current-price]');
            const compareEl = priceRoot.querySelector('[data-product-compare-price]');
            const discountBadge = priceRoot.querySelector('.discount-badge');
            const priceSave = priceRoot.querySelector('.price-save');
            if (!currentEl) return;

            let variantId = String(priceRoot.getAttribute('data-variant-id') || '');
            let basePrice = parseInt(priceRoot.getAttribute('data-base-price'), 10) || 0;
            let baseCompare = parseInt(priceRoot.getAttribute('data-base-compare-price'), 10) || 0;

            if (variantSelect) {
                variantId = String(variantSelect.value || variantId);
                const selectedOption = variantSelect.options[variantSelect.selectedIndex];
                if (selectedOption) {
                    basePrice = parseInt(selectedOption.getAttribute('data-price'), 10) || basePrice;
                    baseCompare = parseInt(selectedOption.getAttribute('data-compare-price'), 10) || 0;
                }
                priceRoot.setAttribute('data-variant-id', variantId);
                priceRoot.setAttribute('data-base-price', String(basePrice));
                priceRoot.setAttribute('data-base-compare-price', String(baseCompare));
            }

            const discounted = discountMap[variantId];
            if (discounted && discounted.original > discounted.final) {
                if (compareEl) {
                    compareEl.style.display = '';
                    compareEl.textContent = formatStoreMoney(discounted.original);
                }
                currentEl.textContent = formatStoreMoney(discounted.final);
                currentEl.classList.add('current-price--discounted');
                if (discountBadge) discountBadge.style.display = 'none';
                if (priceSave) priceSave.style.display = 'none';
            } else {
                currentEl.textContent = formatStoreMoney(basePrice);
                if (baseCompare > basePrice) {
                    if (compareEl) {
                        compareEl.style.display = '';
                        compareEl.textContent = formatStoreMoney(baseCompare);
                    }
                    currentEl.classList.add('current-price--discounted');
                } else {
                    if (compareEl) {
                        compareEl.style.display = 'none';
                        compareEl.textContent = '';
                    }
                    currentEl.classList.remove('current-price--discounted');
                    if (discountBadge) discountBadge.style.display = 'none';
                    if (priceSave) priceSave.style.display = 'none';
                }
            }

            const mobileStickyPrice = document.getElementById('MobileStickyPrice');
            if (mobileStickyPrice) {
                mobileStickyPrice.textContent = currentEl.textContent;
            }
        }

        (function initializeCouponAwarePricing() {
            let discountMap = {};
            let hasPriceTargets = false;

            function applyAllFromCart(cart) {
                discountMap = buildDiscountMap(cart);
                applyCardDiscountPricing(discountMap);
                applyPdpDiscountPricing(discountMap);
            }

            function fetchCartAndApply() {
                if (!hasPriceTargets) return;
                const cartUrl = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
                fetch(cartUrl)
                    .then(function(response) {
                        if (!response.ok) throw new Error('Failed to fetch cart');
                        return response.json();
                    })
                    .then(function(cart) {
                        applyAllFromCart(cart);
                    })
                    .catch(function() {
                        // Ignore fetch errors silently to avoid breaking storefront.
                    });
            }

            document.addEventListener('DOMContentLoaded', function() {
                hasPriceTargets = Boolean(
                    document.querySelector('[data-product-card-price-root]') ||
                    document.querySelector('[data-product-price-root]')
                );

                if (!hasPriceTargets) return;

                if ('requestIdleCallback' in window) {
                    requestIdleCallback(fetchCartAndApply, { timeout: 1800 });
                } else {
                    setTimeout(fetchCartAndApply, 600);
                }
            });

            document.addEventListener('change', function(event) {
                if (event.target && event.target.classList && event.target.classList.contains('product-variant-id-select')) {
                    setTimeout(function() {
                        applyPdpDiscountPricing(discountMap);
                    }, 0);
                }
            });

            window.addEventListener('cart:updated', function(event) {
                if (event.detail && event.detail.cart) {
                    applyAllFromCart(event.detail.cart);
                } else {
                    fetchCartAndApply();
                }
            });
        })();

    


        // AJAX Add to Cart - fast and smooth
        document.addEventListener('submit', function(e) {
            const form = e.target;
            if (form && form.classList.contains('product-form') && form.querySelector('[name="add"]')) {
                e.preventDefault();
                e.stopPropagation();
                
                // Ensure routes are available
                if (!window.routes || !window.routes.cart_add_url) {
                    alert('Cart system not initialized. Please refresh the page.');
                    return;
                }
                
                const formData = new FormData(form);
                const addButton = form.querySelector('[name="add"]');
                const originalText = addButton ? addButton.innerHTML : '';
                const originalDisabled = addButton ? addButton.disabled : false;
                
                // Disable button and show loading state
                if (addButton) {
                    addButton.disabled = true;
                    addButton.style.opacity = '0.7';
                    addButton.style.cursor = 'wait';
                    const loadingText = addButton.querySelector('i') ? '<i class="las la-spinner la-spin"></i> Adding...' : 'Adding...';
                    addButton.innerHTML = loadingText;
                }
                
                // Add to cart via AJAX - optimized for speed
                const startTime = Date.now();
                
                // FormData automatically sets Content-Type with boundary, don't set it manually
                fetch(window.routes.cart_add_url, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                .then(response => {
                    // Check if response is ok
                    if (!response.ok) {
                        // Try to get error message from response
                        return response.text().then(text => {
                            let errorMsg = 'Network response was not ok';
                            try {
                                const errorData = JSON.parse(text);
                                errorMsg = errorData.description || errorData.message || errorMsg;
                            } catch (e) {
                                // If not JSON, use status text
                                errorMsg = response.statusText || errorMsg;
                            }
                            throw new Error(errorMsg);
                        });
                    }
                    // Check content type before parsing JSON
                    const contentType = response.headers.get('content-type');
                    if (contentType && contentType.includes('application/json')) {
                        return response.json();
                    } else {
                        // If not JSON, return empty object (some Shopify responses are HTML)
                        return {};
                    }
                })
                .then(data => {
                    // Immediately update cart count (optimistic update for instant feedback)
                    if (window.updateCartCount) {
                        window.updateCartCount();
                    }
                    
                    // Fetch updated cart FIRST, then open drawer with data already loaded (faster UX)
                    fetch(window.routes.cart_url + '.js')
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Failed to fetch cart');
                            }
                            return response.json();
                        })
                        .then(cart => {
                            window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
                            // Wait for function to be available, then update drawer content BEFORE opening
                            let retryCount = 0;
                            const maxRetries = 30; // 3 seconds max wait
                            
                            function tryUpdateCart() {
                                if (window.updateCartDrawerContent && typeof window.updateCartDrawerContent === 'function') {
                                    // Update drawer content FIRST with cart data
                                    window.updateCartDrawerContent(cart);
                                    
                                    // THEN open drawer (now it has data already loaded - instant display)
                                    if (window.openCartDrawer) {
                                        window.openCartDrawer();
                                    }
                                } else if (retryCount < maxRetries) {
                                    retryCount++;
                                    // Retry after a short delay if function not available yet
                                    setTimeout(tryUpdateCart, 100);
                                } else {
                                    // Fallback: open drawer even if update function not available
                                    if (window.openCartDrawer) {
                                        window.openCartDrawer();
                                    }
                                    if (window.updateCartCount) {
                                        window.updateCartCount();
                                    }
                                }
                            }
                            tryUpdateCart();
                        })
                        .catch(function(err) {
                            // Open drawer even if fetch fails (will show old content)
                            if (window.openCartDrawer) {
                                window.openCartDrawer();
                            }
                            // Update cart count even if fetch fails
                            if (window.updateCartCount) {
                                window.updateCartCount();
                            }
                        });
                    
                    // Show success notification (non-blocking)
                    if (window.showCartNotification) {
                        window.showCartNotification('Product added to cart', 'success');
                    }
                    
                    // Re-enable button with success state
                    if (addButton) {
                        const elapsed = Date.now() - startTime;
                        const minDelay = 300; // Minimum visual feedback time
                        const delay = Math.max(0, minDelay - elapsed);
                        
                        setTimeout(function() {
                            const successText = addButton.querySelector('i') ? '<i class="las la-check"></i> Added!' : 'Added!';
                            addButton.innerHTML = successText;
                            addButton.style.opacity = '1';
                            addButton.style.background = '#28a745';
                            addButton.style.borderColor = '#28a745';
                            
                            // Reset button after 1.2 seconds
                            setTimeout(function() {
                                addButton.disabled = originalDisabled;
                                addButton.innerHTML = originalText;
                                addButton.style.background = '';
                                addButton.style.borderColor = '';
                                addButton.style.cursor = '';
                            }, 1200);
                        }, delay);
                    }
                })
                .catch(function(error) {
                    // Show error notification with actual error message
                    const errorMessage = error.message || 'Error adding to cart';
                    if (window.showCartNotification) {
                        window.showCartNotification(errorMessage, 'error');
                    } else {
                        // Fallback to alert if notification system not available
                        alert(errorMessage);
                    }
                    
                    // Re-enable button on error
                    if (addButton) {
                        addButton.disabled = originalDisabled;
                        addButton.innerHTML = originalText;
                        addButton.style.opacity = '1';
                        addButton.style.cursor = '';
                        addButton.style.background = '';
                    }
                });
            }
        });

        function initProductCardVariants(scope) {
            const root = scope || document;
            const forms = root.querySelectorAll('.product-card-form:not([data-card-variant-ready])');

            forms.forEach(function(form) {
                form.setAttribute('data-card-variant-ready', 'true');

                const card = form.closest('[data-product-card]');
                const variantSelect = form.querySelector('.product-card-variant-id');
                const variantRows = form.querySelectorAll('.product-card-variant');
                const optionSelects = form.querySelectorAll('.product-card-variant-select');
                const addButton = form.querySelector('[data-product-card-add]');
                const viewLink = form.querySelector('[data-product-card-view]');
                const priceRoot = card ? card.querySelector('[data-product-card-price-root]') : null;
                const dataScript = form.querySelector('.product-card-variant-data');

                if (!variantSelect || !variantRows.length || !dataScript) {
                    return;
                }

                let variants = [];
                try {
                    variants = JSON.parse(dataScript.textContent);
                } catch (error) {
                    return;
                }

                function getSelectedOptions() {
                    const selectedOptions = [];
                    variantRows.forEach(function(row) {
                        const idx = parseInt(row.dataset.optionIndex, 10);
                        const select = row.querySelector('.product-card-variant-select');
                        const activePill = row.querySelector('.product-card-variant-pill.is-selected');

                        if (select) {
                            selectedOptions[idx] = select.value;
                        } else if (activePill) {
                            selectedOptions[idx] = activePill.dataset.value;
                        }
                    });
                    return selectedOptions;
                }

                function updateCardVariant() {
                    const selectedOptions = getSelectedOptions();

                    let matchedVariant = null;
                    for (let i = 0; i < variants.length; i++) {
                        const variant = variants[i];
                        let match = true;
                        for (let j = 0; j < selectedOptions.length; j++) {
                            if (variant.options[j] !== selectedOptions[j]) {
                                match = false;
                                break;
                            }
                        }
                        if (match) {
                            matchedVariant = variant;
                            break;
                        }
                    }

                    if (!matchedVariant) {
                        return;
                    }

                    variantSelect.value = matchedVariant.id;

                    const price = parseInt(matchedVariant.price, 10) || 0;
                    const comparePrice = parseInt(matchedVariant.compare_at_price, 10) || 0;
                    const available = !!matchedVariant.available;
                    const labels = window.variantStrings || {};

                    if (priceRoot) {
                        priceRoot.setAttribute('data-variant-id', matchedVariant.id);
                        priceRoot.setAttribute('data-base-price', price);
                        priceRoot.setAttribute('data-base-compare-price', comparePrice);

                        const compareEl = priceRoot.querySelector('[data-price-compare]');
                        const finalEl = priceRoot.querySelector('[data-price-final]');

                        if (finalEl) {
                            finalEl.textContent = formatStoreMoney(price);
                            if (comparePrice > price) {
                                if (compareEl) {
                                    compareEl.style.display = '';
                                    compareEl.textContent = formatStoreMoney(comparePrice);
                                }
                                finalEl.classList.remove('price-final--regular');
                            } else {
                                if (compareEl) {
                                    compareEl.style.display = 'none';
                                    compareEl.textContent = '';
                                }
                                finalEl.classList.add('price-final--regular');
                            }
                        }
                    }

                    if (addButton) {
                        addButton.disabled = !available;
                        addButton.textContent = available
                            ? (labels.addToCart || 'Add to cart')
                            : (labels.soldOut || 'Sold out');
                    }

                    if (viewLink) {
                        const baseUrl = viewLink.getAttribute('data-product-url') || viewLink.href.split('?')[0];
                        viewLink.href = available
                            ? baseUrl + '?variant=' + matchedVariant.id
                            : baseUrl;
                    }

                    if (card) {
                        if (comparePrice > price) {
                            card.classList.add('offer');
                        } else {
                            card.classList.remove('offer');
                        }
                    }
                }

                optionSelects.forEach(function(sel) {
                    sel.addEventListener('change', updateCardVariant);
                });

                form.addEventListener('click', function(event) {
                    const pill = event.target.closest('.product-card-variant-pill');
                    if (!pill || !form.contains(pill)) {
                        return;
                    }

                    const group = pill.closest('.product-card-variant__pills');
                    if (!group) {
                        return;
                    }

                    group.querySelectorAll('.product-card-variant-pill').forEach(function(button) {
                        button.classList.remove('is-selected');
                    });
                    pill.classList.add('is-selected');
                    updateCardVariant();
                });

                updateCardVariant();
            });
        }

        window.initProductCardVariants = initProductCardVariants;

        function initProductCardQuantity(scope) {
            const root = scope || document;
            const qtyBlocks = root.querySelectorAll('[data-product-card-qty]:not([data-card-qty-ready])');

            qtyBlocks.forEach(function(wrap) {
                wrap.setAttribute('data-card-qty-ready', 'true');

                const input = wrap.querySelector('.product-card-qty__input');
                const dec = wrap.querySelector('.product-card-qty__dec');
                const inc = wrap.querySelector('.product-card-qty__inc');

                if (!input || !dec || !inc) {
                    return;
                }

                function normalizeQuantity() {
                    input.value = Math.max(1, parseInt(input.value, 10) || 1);
                }

                dec.addEventListener('click', function() {
                    input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
                });

                inc.addEventListener('click', function() {
                    input.value = (parseInt(input.value, 10) || 1) + 1;
                });

                input.addEventListener('input', normalizeQuantity);
                input.addEventListener('change', normalizeQuantity);
            });
        }

        window.initProductCardQuantity = initProductCardQuantity;

        document.addEventListener('DOMContentLoaded', function() {
            initProductCardVariants();
            initProductCardQuantity();
        });

        document.addEventListener('shopify:section:load', function() {
            initProductCardVariants();
            initProductCardQuantity();
        });